export const SEND_OTP_INIT_ACTION = "SEND_OTP_INIT_ACTION";
export const SEND_OTP_SUCCESS_ACTION = SEND_OTP_INIT_ACTION + "_SUCCESS";
export const SEND_OTP_FAIL_ACTION = SEND_OTP_INIT_ACTION + "_ERROR";

export const VERIFY_OTP_INIT_ACTION = "VERIFY_OTP_INIT_ACTION";
export const VERIFY_OTP_SUCCESS_ACTION = VERIFY_OTP_INIT_ACTION + "_SUCCESS";
export const VERIFY_OTP_FAIL_ACTION = VERIFY_OTP_INIT_ACTION + "_ERROR";

export const RESEND_OTP_INIT_ACTION = "RESEND_OTP_INIT_ACTION";
export const RESEND_OTP_SUCCESS_ACTION = RESEND_OTP_INIT_ACTION + "_SUCCESS";
export const RESEND_OTP_FAIL_ACTION = RESEND_OTP_INIT_ACTION + "_ERROR";

export const SET_NEW_PWD_INIT_ACTION = "SET_NEW_PWD_INIT_ACTION";
export const SET_NEW_PWD_SUCCESS_ACTION = SET_NEW_PWD_INIT_ACTION + "_SUCCESS";
export const SET_NEW_PWD_FAIL_ACTION = SET_NEW_PWD_INIT_ACTION + "_ERROR";

export const REDIRECT_INIT_ACTION = "REDIRECT_INIT_ACTION";
export const REDIRECT_SUCCESS_ACTION = REDIRECT_INIT_ACTION + "_SUCCESS";
export const REDIRECT_FAIL_ACTION = REDIRECT_INIT_ACTION + "_ERROR";
